import get from 'growth-payments-core/object/get';
import { COMMERCE_HOME_PRE_TOOL_START, KYC_EMBEDDED_FALLBACK_EXPERIENCE, PRE_APPROVED, PRODUCT_BUILDER } from '../constants/gates';
import { useSet } from '../set/useSet';
import { getAuth, useAuth } from './user';
export const useGates = () => {
  const [userInfo] = useAuth();
  const gatesSet = useSet(get(userInfo, 'gates'));
  return gatesSet;
};
export const getGates = () => {
  return get(getAuth(), 'gates');
};
export const useIsUngated = (...gatesToCheck) => {
  const gates = useGates();
  return gatesToCheck.every(gate => gates.has(gate));
};
export const useIsUngatedForPreApproval = () => useIsUngated(PRE_APPROVED);
export const useIsUngatedForKycEmbeddedFallbackExperience = () => useIsUngated(KYC_EMBEDDED_FALLBACK_EXPERIENCE);
export const useIsUngatedForCommerceHomePreToolStart = () => useIsUngated(COMMERCE_HOME_PRE_TOOL_START);
export const useIsUngatedForProductBuilder = () => useIsUngated(PRODUCT_BUILDER);